import * as React from "react";
import { observer } from "mobx-react-lite";
import { Select } from "antd";
import { SelectValue } from "antd/lib/select";
import TasksGridVisualStore from "../stores/TasksGridVisualStore";
import AppModal from "../../common/components/AppModal";
import { UNASSIGNED_FILTER_VALUE } from "./FiltersControls";

type Props = {
    store: TasksGridVisualStore;
};

const TasksAssignDialog: React.FC<Props> = ({ store }) => {
    const [user, setUser] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        setUser(undefined);
    }, [store.commonUsersInSelectedTasks]);

    const handleSubmit = () => {
        if (!user) {
            return;
        }

        if (user === UNASSIGNED_FILTER_VALUE) {
            store.updateFieldsBulk({ AssignedTo: null });
            store.setTaskAssignDialogVisible(false);
            return;
        }

        store.assignTasksToUser(store.selectedRows, user);
    };

    return (
        <AppModal
            title="Assign tasks to user"
            destroyOnClose
            open={store.taskAssignDialogVisible}
            onCancel={() => store.setTaskAssignDialogVisible(false)}
            className="alpha-modal"
            cancelButtonTitle="Cancel"
            onCancelClick={() => store.setTaskAssignDialogVisible(false)}
            cancelButtonProps={{ size: undefined }}
            submitButtonTitle="Assign"
            onSubmitClick={handleSubmit}
            submitButtonProps={{
                disabled: !user || store.submittingTaskBatchAssignment,
                loading: store.submittingTaskBatchAssignment,
                size: undefined,
            }}
        >
            <Select
                value={user}
                onChange={(val: SelectValue) => {
                    setUser(val ? val.toString() : undefined);
                }}
                style={{ width: "100%" }}
            >
                <Select.Option
                    key={UNASSIGNED_FILTER_VALUE}
                    value={UNASSIGNED_FILTER_VALUE}
                >
                    {UNASSIGNED_FILTER_VALUE}
                </Select.Option>
                {store.commonUsersInSelectedTasks &&
                    store.commonUsersInSelectedTasks.map((u) => (
                        <Select.Option key={u.id} value={u.id}>
                            {u.userName}
                        </Select.Option>
                    ))}
            </Select>
        </AppModal>
    );
};

export default observer(TasksAssignDialog);
